module.exports = __webpack_public_path__ + "static/domsearch-03f4207495f9ba7931f1e7fcd2007d25.png";